import React from 'react';

const stateMap = {
  connected: 'bg-green-500 shadow-[0_0_6px_rgba(34,197,94,0.6)]',
  disconnected: 'bg-red-500 shadow-[0_0_6px_rgba(239,68,68,0.6)]',
  idle: 'bg-gray-600',
  live: 'bg-red-600 shadow-[0_0_8px_rgba(239,68,68,0.6)] animate-pulse',
  warning: 'bg-amber-500 shadow-[0_0_6px_rgba(245,158,11,0.6)]'
};

export const TallyLight = ({ state = 'idle', className = '', label }) => {
  const color = stateMap[state] || stateMap.idle;

  return (
    <div className={`flex items-center gap-1.5 ${className}`}>
      <div className={`w-3 h-3 rounded-full ${color}`} />
      {label && (
        <span className="text-[10px] font-mono uppercase tracking-wider text-gray-400">
          {label}
        </span>
      )}
    </div>
  );
};
